import { RegvarModel } from '../models/RegvarModel';
const isNotValidationGroupError = (error)=>{
    return error instanceof RegvarModel;
};
export default isNotValidationGroupError;
